export default __webpack_public_path__ + "static/media/hero-img.8c47f313.png";